var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalCreate',{ref:"modalCreate",attrs:{"wip":_vm.wip,"submitting":_vm.submitting},on:{"form-data-changed":_vm.setWip,"form-data-submit":_vm.doSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }